
export enum ProductOrientation {
    'UNKNOWN',
    'FRONT',
    'SIDE',
    'FLATPACK',
    'FRONT_90',
    'SIDE_90',
    'FLATPACK_90'
}
